import React, { memo, SVGProps } from 'react'

export const DotsHorizontal = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 13.3842C4.76481 13.3842 5.3842 12.7648 5.3842 12C5.3842 11.2352 4.76481 10.6158 4 10.6158C3.23519 10.6158 2.6158 11.2352 2.6158 12C2.6158 12.7648 3.23519 13.3842 4 13.3842ZM4 15C2.34111 15 1 13.6589 1 12C1 10.3411 2.34111 9 4 9C5.65889 9 7 10.3411 7 12C7 13.6589 5.6535 15 4 15Z"
      fill="currentColor"
    />
    <path
      d="M12 13.3842C12.7648 13.3842 13.3842 12.7648 13.3842 12C13.3842 11.2352 12.7648 10.6158 12 10.6158C11.2352 10.6158 10.6158 11.2352 10.6158 12C10.6158 12.7648 11.2352 13.3842 12 13.3842ZM12 15C10.3465 15 9 13.6589 9 12C9 10.3411 10.3411 9 12 9C13.6589 9 15 10.3411 15 12C15 13.6589 13.6535 15 12 15Z"
      fill="currentColor"
    />
    <path
      d="M20 13.3842C20.7648 13.3842 21.3842 12.7648 21.3842 12C21.3842 11.2352 20.7648 10.6158 20 10.6158C19.2352 10.6158 18.6158 11.2352 18.6158 12C18.6158 12.7648 19.2352 13.3842 20 13.3842ZM20 15C18.3465 15 17 13.6589 17 12C17 10.3411 18.3411 9 20 9C21.6589 9 23 10.3411 23 12C23 13.6589 21.6589 15 20 15Z"
      fill="currentColor"
    />
  </svg>
))
